@if (entry?.base?.display) {
  <div>
    <form [formGroup]="medicationForm" [connect]="['payloadStates', 'MedigapEnrollmentMedications', 'medicationForm']">
      <mat-card appearance="outlined" formArrayName="medications">
        <h2>List all prescription drugs you are currently taking or have been medically advised to take.</h2>
        <mat-divider></mat-divider>
        @for (medication of medFormControls.medications['controls']; track medication; let i = $index) {
          <div>
            @if (formValuesAsJson.medications.length > 1 && i > 0) {
              <mat-divider></mat-divider>
            }
            <br>
            <div class="single-drug-container" [formGroupName]="i">
              <mat-form-field appearance="outline" hintLabel="Max 50 characters">
                <mat-label>Medication <span style="color: #a71919;">*</span></mat-label>
                <input matInput type="text" maxlength="50" placeholder="Name of the medication" formControlName="medicationName">
                @if (!isValid) {
                  <mat-error>Required</mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="outline" hintLabel="Max 10 characters">
                <mat-label>Dosage <span style="color: #a71919;">*</span></mat-label>
                <input matInput type="text" #input maxlength="10" placeholder="e.g. 10mg" formControlName="medicationDosage">
                @if (!isValid) {
                  <mat-error>Required</mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="outline" hintLabel="Max 50 characters">
                <mat-label>Condition for which prescribed <span style="color: #a71919;">*</span></mat-label>
                <input matInput type="text" maxlength="50" placeholder="e.g. hypertension" formControlName="conditionForMed">
                @if (!isValid) {
                  <mat-error>Required</mat-error>
                }
              </mat-form-field>
              <div class="radio-label-and-buttons">
                <mat-label>Currently taking? <span style="color: #a71919;">*</span></mat-label>
                <mat-radio-group class="currently-taking-radio-group" label="Currently taking?" formControlName="currentlyTaking">
                  <mat-radio-button checked value="Yes">Yes</mat-radio-button>
                  <mat-radio-button value="No">No</mat-radio-button>
                  @if (!isValid) {
                    <mat-error>Required</mat-error>
                  }
                </mat-radio-group>
              </div>
              <button class="remove-button" type="button" mat-raised-button color="warn" (click)="removeMedication(i)">
                REMOVE
              </button>
            </div>
          </div>
        }
        <mat-card-actions class="button-container">
          <button mat-raised-button (click)="addMedication()">
            Add Medication
          </button>
        </mat-card-actions>
      </mat-card>
    </form>
  </div>
}
